<template>
<div class="content">
<v-card>
<v-card v-if="canEdit">
  <v-card-text>
    <v-btn @click="edit" v-if="!editor">Edit</v-btn>
    <v-btn @click="save" v-if="editor">Save</v-btn>
    <v-btn @click="cancel" v-if="editor">Cancel</v-btn>
    <v-btn @click="remove" v-if="editor">Delete</v-btn>
  </v-card-text>
</v-card>
<v-card :loading="waiting" v-if="!editor">
  <v-card-title>{{ model.title }}</v-card-title>
  <v-card-text v-html="model.content"> </v-card-text>
</v-card>
<v-card v-if="!waiting && editor">
  <v-card-title>Edit Content</v-card-title>
  <v-card-text>
    <SchemaForm  :model="model" item="content" v-on:save="save" v-on:cancel="refresh"/>
  </v-card-text>
</v-card>
<v-card v-if="!waiting && editor">
  <v-card-title>Attach Files</v-card-title>
  <v-card-subtitle v-if="!model.uuid">
    Save new content to add attachments
  </v-card-subtitle>
  <v-card-text>
    <FileUpload v-if="editor && model.uuid" :parent="model" :uuid="0"/>
  </v-card-text>
</v-card>

</v-card>
</div>
</template>

<script>
import SchemaForm from './SchemaForm.vue'
import FileUpload from './FileUpload.vue'
import axios from '../lib/axios'
const log=console.log

const refresh = function() {
    var self = this

    if (!this.name) return

    self.editor = false
    self.waiting = true

    axios.get('/api/docs/name/'+this.name)
    .then((response) => {
	self.waiting = false
        var d = response.data;
        if (d.status!="success") {
            throw d;
        }
        self.model = response.data.data
    })
    .catch((err) => {
        self.waiting = false
        log('ERROR','docs:refresh', err.message)
    })
}

export default {
    components: {
        SchemaForm,
        FileUpload
    },
    data: function() {
        return {
            model: {
                _name: this.name, 
                title: '', // 'Loading ...',
                content: '',
                uuid: 0,
                ts_created: '',
                ts_modified: ''
            },
            waiting: false,
            editor: false
        }
    },
    save: function(d) {
      let data = {...this.proj, ...d}
      let self = this

      axios.post('/api/content/'+(data.uuid||0),
          data
      ).then(function(r){
          let x = r.data
          if (x.status != "success") throw (x.message || "UNKOWN")
          self.model = x.data
          //self.refresh()
          if (confirm("Your content is saved. OK to return to view mode, or Cancel to stay in editor.")) {
              self.editor = false
          }
      })
      .catch(function(e){
          console.log('ERROR','Project:save', 'Attempt failed', e)
          self.$store.commit('showMessage', { content: e.message||"ERROR", color: 'error' })
      })
    },
    props: {
        name : String
    },
    methods: {
        menuToggle() { this.showMenu != this.showMenu },
        edit() { this.editor = true },
        save: function(d) {
            let data = {...this.model, ...d}
            let self = this
            axios.post('/api/content/'+(data.uuid||0),
                  data
            ).then(function(r){
                let x = r.data
                if (x.status != "success") throw (x.message || "UNKOWN")
                self.model = x.data
                self.refresh()
                if (!confirm("Your content is saved. OK to return to view mode, or Cancel to stay in editor.")) {
                    self.edit()
                }
            })
            .catch(function(e){
                console.log('ERROR','Project:save', 'Attempt failed', e);
                self.$store.commit('showMessage', { content: e.message||"ERROR", color: 'error' })
            });

        },
        cancel() { this.editor = false; this.refresh() },
        remove() {},
        refresh
    },
    watch: {
        'name': function() {
            this.refresh()
        }
    },
    created: function() {
        this.refresh()
    },
    computed: {
        canEdit() {
            return (this.$store.getters.roles.indexOf('content') >= 0)
        }
    }
}
</script>

<style>
.item-list {
    margin-left: auto;
    margin-right:auto;
}
.item-list td.title {
    text-align: left;
}
.item-list td.amount {
    text-align: right;
}
</style>
